import React from "react";

export default function HoldSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clip-path="url(#clip0_1_61166)">
        <path
          d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
          stroke="#2C3E50"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 6.66602V9.99935"
          stroke="#2C3E50"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10 13.334H10.0083"
          stroke="#2C3E50"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_61166">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
